template = require('./calendar.html.slim')

angular.module('wbComponents').directive 'wbCalendar',
[ ->
  replace: true
  restrict: "E"
  scope:
    year: "@"
    month: "@"
    highlights: "="

  templateUrl: template
  link: ($scope, $el, $attrs) ->
    month = moment().locale('en').year($scope.year).month($scope.month)
    endOfMonthDate = month.endOf('month').date()

    # Generate an array of objects with the dates of the specified month
    $scope.getDates = =>
      dates = []

      # Figure out the extra preceding days in the first week of the month
      startingDay = month.date(1).day()
      unless startingDay is 0
        for day in [startingDay-1..0]
          extraDate = moment().locale('en').year($scope.year).month($scope.month).date(-(day))
          dates.push {
            date: extraDate.date()
            extra: true
            week: month.date(1).week()
            day: extraDate.day()
          }

      # Populate the calendar with the dates
      for date in [1..endOfMonthDate]
        dates.push {
          date: date
          highlight: if $scope.highlights.indexOf(date) isnt -1 then true else false
          week: month.date(date).week()
          day: month.date(date).day()
        }

      # Figure out the extra following days in the last week of the month
      endingDay = month.endOf('month').day()
      unless endingDay is 6
        for day in [endingDay+1..6]
          extraDate = moment().locale('en').year($scope.year).month($scope.month).date(endOfMonthDate + (day-endingDay))
          dates.push {
            date: extraDate.date()
            extra: true
            week: month.endOf('month').week()
            day: extraDate.day()
          }

      # Split it up in arrays for ng-repeat
      firstWeek = month.date(1).week()
      lastWeek = month.endOf('month').week()

      datesArray = []
      for i in [firstWeek..lastWeek]
        datesArray.push dates.splice(0,7)

      datesArray

    $scope.dates = $scope.getDates()
]
